import KafkaRestClient from '../kafka/KafkaRestClient';
import { AiContentDownloadEventFactory } from './AiContentDownloadEventFactory';
import { AiContentServiceCommonOptions } from './AiContentServiceTypes';

export type AiContentDownloadServiceOptions = AiContentServiceCommonOptions;

async function publishEvent(args: AiContentDownloadServiceOptions): Promise<void> {
    const {
        aiContentId,
        lastAiContentId,
        voiceId,
        aiContentVoiceoverType,
        cookies,
        currentUrl,
        referrer,
        headers,
        geo,
    } = args;

    const visitorIdCookie = cookies.get('VID')?.value ?? null;
    const loginSessionToken = cookies.get('login_session')?.value;
    const ipAddress = headers.get('X-Forwarded-For') ?? null;

    const event = await AiContentDownloadEventFactory.create({
        aiContentId,
        lastAiContentId,
        voiceId,
        aiContentVoiceoverType,
        visitorCookieId: visitorIdCookie,
        sessionToken: loginSessionToken,
        currentUrl,
        referrer,
        headers,
        geo,
        ipAddress,
    });

    await KafkaRestClient.produce(event);
}

export const AiContentDownloadService = { publishEvent };
